import script from "./DescriptionStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./DescriptionStep.vue?vue&type=script&setup=true&lang=ts"

import "./DescriptionStep.vue?vue&type=style&index=0&id=95cb3ef4&lang=scss&scoped=true"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95cb3ef4"]])

export default __exports__